/* Optional printed voucher. The paid physical item is deliberately separate from
   the digital voucher so the existing PDF fulfilment continues unchanged. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) api.init(root);
})(typeof window !== 'undefined' ? window : globalThis, function () {
  function cartAddUrl(rootUrl) {
    return (rootUrl || '/').replace(/\/?$/, '/') + 'cart/add.js';
  }

  function buildCartItems(options) {
    var voucherVariantId = Number(options.voucherVariantId);
    if (!Number.isSafeInteger(voucherVariantId) || voucherVariantId < 1) throw new Error('Invalid voucher variant');
    var properties = Object.assign({}, options.properties || {});
    if (!options.printSelected) return [{ id: voucherVariantId, quantity: 1, properties: properties }];

    var printVariantId = Number(options.printVariantId);
    if (!Number.isSafeInteger(printVariantId) || printVariantId < 1) throw new Error('Invalid print variant');
    if (!options.pairId) throw new Error('Missing print pair');
    properties._print_pair = options.pairId;
    return [
      { id: voucherVariantId, quantity: 1, properties: properties },
      { id: printVariantId, quantity: 1, properties: { _print_pair: options.pairId } }
    ];
  }

  function init(win) {
    var form = win.document.getElementById('voucher-form');
    var checkbox = win.document.getElementById('physical-voucher');
    if (!form || !checkbox) return;
    checkbox.disabled = false;
    form.addEventListener('submit', async function (event) {
      if (!checkbox.checked) return; // Native add-to-cart remains the digital fallback.
      event.preventDefault();
      if (!form.reportValidity()) return;
      var button = form.querySelector('button[type="submit"]');
      var error = win.document.getElementById('physical-voucher-error');
      if (error) error.hidden = true;
      if (button) button.disabled = true;
      try {
        var data = new win.FormData(form);
        var properties = {};
        data.forEach(function (value, key) {
          var match = /^properties\[(.+)\]$/.exec(key);
          if (match && String(value).trim()) properties[match[1]] = String(value);
        });
        var pairId = 'print-' + (win.crypto && win.crypto.randomUUID ? win.crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2));
        var items = buildCartItems({
          voucherVariantId: data.get('id'),
          printVariantId: checkbox.dataset.variantId,
          properties: properties,
          printSelected: true,
          pairId: pairId
        });
        var shopRoot = win.Shopify && win.Shopify.routes && win.Shopify.routes.root || '/';
        var response = await win.fetch(cartAddUrl(shopRoot), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!response.ok) throw new Error('Shopify cart rejected printed voucher');
        win.location.assign(shopRoot.replace(/\/?$/, '/') + 'cart');
      } catch (cause) {
        if (error) error.hidden = false;
        if (button) button.disabled = false;
      }
    });
  }
  return { buildCartItems: buildCartItems, cartAddUrl: cartAddUrl, init: init };
});
